import React from 'react'

import axios from "axios";
import Swal from 'sweetalert2';
import config from "../../config"
import { useParams } from 'react-router-dom';
import Moment from 'react-moment';

const Wallet_recharge_invoice = () => {
    let transaction_id = useParams();
    console.log("transaction_id= ==" , transaction_id)
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
    const[state, setState ]= React.useState({ customer_detail: {},
        company_detail: {},
        transaction: {}})
  
    React.useEffect(()=>{
    get_wallet_balance(0,true)
   },[])

    const get_wallet_balance=()=>{
     let dataToSend = {customer_id : userData.customer_id , transaction_id:transaction_id.transaction_id};
    
      let url = config.apiUrl + '/user/get_wallet_recharge_invoice';
      axios.post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
            if(res.data.status==true){
setState({customer_detail: res.data.customer_detail,
    company_detail: res.data.company_detail,
    transaction: res.data.transaction})
            
     }
    else{
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          Toast.fire({
            background:"#a61c09",
            type: 'Unsuccess',
            title: "Something Went Wrong !",
            color:"white"
          });
    } })
        
          .catch((error) => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              Toast.fire({
                background:"#a61c09",
                type: 'Unsuccess',
                title: "Something Went Wrong !",
                color:"white"
              });
          });    
    }
    
  return (
    <div style={{
        fontSize: "12px",
        margin: "0",
        padding: "3mm",
        background: "rgba(235,235,235,1)",
        backgroundColor: "rgba(235,235,235,1)",
        fontFamily: "arial,sans-serif",
        lineHeight: "18px",
    }}>
      <div class="container mt-3 wrap" style={{ width: "75%"}}>
    <div class="card mb-1">
        <div class="card-body">
          <div class="text-end">
            <h4>Invoice</h4>
            <p>Invoice Number - {state.transaction.transaction_id?state.transaction.transaction_id:""}<br/>Invoice Date - {state.transaction.created? <><Moment format="MMM DD YYYY">
        {new Date(state.transaction.created*1000)}
</Moment> </>:""}</p>
          </div>
          <table class="table">
              <tbody>
                <tr>
                  <td style={{width: "40%"}}>
                    <div class="mb-3">
                      <h5 class="text-capitalize">{state.company_detail.company_name?state.company_detail.company_name:""}</h5>
                    <p>
                    {state.company_detail.company_address?state.company_detail.company_address:""}, {state.company_detail.city_name?state.company_detail.city_name:""}, {state.company_detail.state_name?state.company_detail.state_name:""}<br/>
                    {state.company_detail.email?state.company_detail.email:""} <br/>
                      <small>GST: {state.company_detail.invoice_gst?state.company_detail.invoice_gst:""}</small> <br/>
                      <small>PAN: {state.company_detail.invoice_pan?state.company_detail.invoice_pan:""}</small>
                    </p>
                    </div>
                  </td>
                  <td>&nbsp;</td>
                  <td style={{width: "40%"}} class="text-end">
                    <h5 class="text-capitalize">{state.customer_detail.company_name?state.customer_detail.company_name:""}</h5>
                    <p>
                    {state.customer_detail.address?state.customer_detail.address:""}, {state.customer_detail.city_name?state.customer_detail.city_name:""}, {state.customer_detail.state_name?state.customer_detail.state_name:""} <br/>
                      <small>GST: {state.customer_detail.gst_number?state.customer_detail.gst_number:""}</small> <br/>
                      <small>PAN: {state.customer_detail.pan_number?state.customer_detail.pan_number:""}</small>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
    </div> 

    <div class="card mb-1">
      <div class="card-body">
        <div class="table-responsive">
            <table class="table table-striped">
                <thead class="">
                  <tr>
                    <th>Description</th>
                    <th>Price</th>
                    <th>Discount</th>
                    <th>Qty</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
  <tr>
    <td>996111-SHIPPING LOGISTICS SERVICE</td>
    <td>₹{(state.transaction.amount / 1.18).toFixed(2)}</td> 
    <td>-</td>
    <td>1</td>
    <td>₹{(state.transaction.amount / 1.18).toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="3"></td>
    <td>SUBTOTAL</td>
    <td>₹{(state.transaction.amount / 1.18).toFixed(2)}</td>
  </tr>
  <tr>
    <td colspan="3"></td>
    <td>GST (18%)</td>
    <td>₹{(state.transaction.amount - state.transaction.amount / 1.18).toFixed(2)}</td>
  </tr>
  <tr class="fw-bold">
    <td colspan="3"></td>
    <td>GRAND TOTAL</td>
    <td>₹{state.transaction.amount}</td>
  </tr>
</tbody>
            </table>
        </div>
      </div>
    </div>
    <div class="card mb-1">
        <div class="card-body">
          <div class="row justify-content-start">
              <div class="col-8">
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                            <tr>
                              <td>Bank Name</td>
                              <td class="fw-bold">{state.company_detail.bank?state.company_detail.bank:""}</td>
                            </tr>
                            <tr>
                              <td>A/C Holder Name</td>
                              <td class="fw-bold">{state.company_detail.entity_name?state.company_detail.entity_name:""}</td>
                            </tr>
                            <tr>
                              <td>A/C Number</td>
                              <td class="fw-bold">{state.company_detail.account_number?state.company_detail.account_number:""}</td>
                            </tr>
                            <tr>
                              <td>IFSC Code</td>
                              <td class="fw-bold">{state.company_detail.ifsc_code?state.company_detail.ifsc_code:""}</td>
                            </tr>
                            <tr>
                              <td>Branch</td>
                              <td class="fw-bold">{state.company_detail.branch?state.company_detail.branch:""}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
              </div>
          </div>
        </div>
    </div>
</div>
    </div>
  )
}

export default Wallet_recharge_invoice
